import { type ReactNode } from 'react';
import { BODY, Divider, PAGE_HEAD } from './rules-typography';
import { CreateIdentity, TrainAlgorithm } from './rules-2-identity';
import { Categories, WhatWeWant } from './rules-2-categories';
import { InfiniteLoop, ProDms, SendCreator } from './rules-2-loop';
import { AutoReply, CompleteData } from './rules-2-data';
import { StrikesList } from './rules-2-strikes';
import { FinalKey, GameSummary, YourProgress } from './rules-3-progress';

function Header(): ReactNode {
  return (
    <header className="space-y-md text-center">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-red">
        The 3333 Games
      </p>
      <h1 className={PAGE_HEAD}>Cómo jugar</h1>
      <p className={BODY}>
        No es teoría, es un sistema. Si lo sigues bien, ganas dinero y subes en
        el ranking.
      </p>
    </header>
  );
}

export function RulesContent2(): ReactNode {
  return (
    <article className="space-y-2xl">
      <Header />
      <CreateIdentity />
      <TrainAlgorithm />
      <Divider />
      <Categories />
      <WhatWeWant />
      <Divider />
      <InfiniteLoop />
      <SendCreator />
      <ProDms />
      <Divider />
      <AutoReply />
      <CompleteData />
      <Divider />
      <StrikesList />
      <YourProgress />
      <Divider />
      <GameSummary />
      <FinalKey />
    </article>
  );
}
